<template>
  <modal
      v-if="showModal"
      @close="$emit('closeModal')"
  >

    <template slot="header">

      <h4 class="modal-title">
        {{ title }}
      </h4>

      <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="$emit('closeModal')"
      >
        <md-icon>clear</md-icon>
      </md-button>

    </template>

    <template slot="body">
      <div
          v-if="errorMessage"
          class="alert alert-danger"
      >
        {{ errorMessage }}
      </div>
      <select-input
          v-model="form.data.attributes.status.name"
          label="Status"
          placeholder="Select Status"
          :options="statusOptions"
          track-by="name"
          label-by="name"
          :allow-empty="false"
          :appendToBody="false"
          :error="apiValidationErrors['status.name']"
      />

      <md-field>
        <label>Reason </label>

        <md-input
            v-model="form.data.attributes.status.reason"
            type="text"
        />
      </md-field>

      <validation-error
          :errors="apiValidationErrors['status.reason']"
      />

    </template>

    <template slot="footer">
      <md-button
          class="md-primary"
          @click="submit"
          :disabled="submitting"
      >
        {{ submitting ? 'Saving...' : 'Save' }}
      </md-button>

      <md-button
          class="md-danger md-simple"
          @click="$emit('closeModal')"
      >
        Close
      </md-button>

    </template>

  </modal>
</template>

<script>
import { Modal } from '@/components';
import formMixin from '@/mixins/form-mixin';
import SelectInput from '@/components/Inputs/SelectInput.vue';
import ValidationError from '@/components/ValidationError.vue';

export default {

  name: 'LabourerStatusModal',

  components: {
    Modal,
    SelectInput,
    ValidationError
  },

  mixins: [formMixin],

  props: {

    title: {
      type: String,
      default: 'Update Status'
    },

    labourer: {
      type: Object,
      required: true
    },

    showModal: {
      type: Boolean,
      default: false
    },

    statusOptions: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      form: {},
      submitting: false,
      errorMessage: null
    };
  },

  created () {
    this.resetForm();
  },

  methods: {

    resetForm () {
      this.errorMessage = null;
      this.form = {
        data: {
          id: this.labourer.id,
          type: 'labourers',
          attributes: {
            status: {
              name: '',
              reason: ''
            }
          }
        }
      };
    },

    async submit() {

      if (this.submitting) {
        return;
      }

      this.submitting = true;

      try {

        this.form.data.id=this.labourer.id
        await this.$store.dispatch(
            'labourers/updateStatus',
            this.form
        );

        this.notifySuccess(
            'Status updated successfully.'
        );

        this.$emit('updated');

        this.$emit('closeModal');

        this.resetForm();

      } catch (e) {
        this.notifyException(e);

      } finally {

        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>

</style>
